import React from "react";
import "./CourseBenefits.css";
const CourseBenefits = () => {
  return (
    <div className="courseBenefitsContainer">
      <h2>
        Benefits of Enrolling in <span>Prizma Academy’s</span> German Course in Bangalore
      </h2>
      <ul>
        <li>
          <span>Experienced Faculty:</span> Our instructors are highly qualified
          and experienced in teaching German as a foreign language. They bring a
          wealth of knowledge and expertise to the classroom.
        </li>
        <li>
          <span>Flexible Timings:</span> We understand that our students have
          diverse schedules. Hence, we offer flexible class timings, including
          weekend and evening batches.
        </li>
        <li>
          <span>Comprehensive Learning Material:</span> Students are provided
          with comprehensive learning materials, including textbooks, workbooks,
          and access to online resources.
        </li>
        <li>
          <span>Personalized Attention:</span> With small class sizes, each
          student receives personalized attention, ensuring a better
          understanding of the language.
        </li>
        <li>
          <span>Cultural Immersion:</span> Beyond language, our German course in
          Bangalore also introduces students to German culture, traditions, and
          etiquette, providing a holistic learning experience.
        </li>
        <li>
          <span>Networking Opportunities:</span> Being part of Prizma Academy
          means joining a community of learners and professionals. Networking
          events and language exchange programs provide opportunities to
          practice German and build connections.
        </li>
      </ul>
    </div>
  );
};

export default CourseBenefits;
